import React, { useCallback, useEffect, useRef, useState } from "react";
import Navbar from "../../layouts/Navbar";
import "../../styles/Comunity.css";
import api from "../../api/config";
import { ToastContainer, toast } from "react-toastify";
import CommunitySkeleton from "../../components/common/CommunitySkeleton";
import NoDataFound from "../../components/common/NoDataFound";
import CommunityList from "../../components/community/CommunityList";
import CommunityRightSection from "../../components/community/CommunityRightSection";
import CommunityModal from "../../components/community/CommunityModal";
import LoginModal from "../../components/common/custom-modals/LoginModal";
import { AsyncPaginate } from "react-select-async-paginate";
import { communityLoadOptions } from "../../utils/loadOptions";
import { communityStateLoadOptions } from "../../utils/loadOptions";
import { communityCityLoadOptions } from "../../utils/loadOptions";

const CommunityBoard = ({ className }) => {
  const [filtersCleared, setFiltersCleared] = useState(false);
  const [showMedia, setShowMedia] = useState(true); // State to track whether to show the map
  const [fetchCommunities, setFetchCommunities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [show, setShow] = useState(false);
  const [businessList, setBusinessList] = useState([]);
  const [isNewCommunity, setIsNewCommunity] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const inputRef = useRef(null);
  const [selectedBusinessTypeFilter, setSelectedBusinessTypeFilter] =
    useState("");
  const [form, setForm] = useState({
    categoryId: "",
    city: "",
    state: "",
    description: "",
  });
  // const [selectedAreaFilter, setSelectedAreaFilter] = useState({
  //   label: "Area",
  //   value: "",
  // });

  const [feedMedia, setFeedMedia] = useState([]);

  const [selectedStateAreaFilter, setSelectedStateAreaFilter] = useState({
    label: "State",
    value: "",
  });
  const [selectedCityAreaFilter, setSelectedCityAreaFilter] = useState({
    label: "City",
    value: "",
  });
  const [showLoginModal, setShowLoginModal] = useState(false);
  const scrollableRef = useRef();

  const handleCloseLoginModal = () => setShowLoginModal(false);
  const handleShowLoginModal = () => setShowLoginModal(true);
  const handleClose = () => {
    console.log("clicked>>>>>>",form,feedMedia);
    setForm({
      ...form,
      categoryId: "",
      state: "",
      city: "",
      description: "",
      images: "",
    });
    setShow(false);
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      marginTop: "8px",
      backgroundColor: "white", // Change background color of the control
      width: "12rem",
      borderColor: "rgb(118, 118, 118)", // Change border color
      minHeight: "25px", // Change the height of the control
      boxShadow: "rgb(118, 118, 118)",
      "&:hover": {
        boxShadow: "transparent",
        borderColor: "black", // Set border color to transparent on hover
      },
      "&:focus": {
        boxShadow: "transparent",
        borderColor: "black",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor:
        state.isSelected || state.isFocused ? "#0d6efd" : "white", // Change background color of selected option
      color: state.isSelected ? "white" : "black", // Change text color of selected option
      padding: 5, // Change padding
      width: "12rem",
    }),
    menu: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#0d6efd" : "transparent",
      backgroundColor: "white", // Change background color of the menu
      borderRadius: "5px", // Change border radius of the menu
      width: "12rem",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black", // Change color of the selected value
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#000",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "black", // Change color of the dropdown indicator
      "&:hover": {
        color: "black", // Change color of the dropdown indicator on hover
      },
    }),
    clearIndicator: (provided) => ({
      ...provided,
      color: "black", // Change color of the clear indicator
      "&:hover": {
        color: "black", // Change color of the clear indicator on hover
      },
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      backgroundColor: "none", // Change color of the indicator separator
    }),
  };

  let data = localStorage.getItem("data");
  data = JSON.parse(data);

  const handleShow = () => {
    if (!data?.jwt) {
      handleShowLoginModal(true);
    } else {
      setShow(true);
    }
  };

  const handleBusinessTypeChange = (e) => {
    setSelectedBusinessTypeFilter(e.target.value);
  };

  const fetchData = async (pageFrom) => {
    // const selectedCity =
    //   selectedAreaFilter?.value !== "" && selectedAreaFilter?.label !== "General"
    //     ? `&city=${selectedAreaFilter?.value}`
    //     : "";

    const selectedCity =
      selectedCityAreaFilter?.value !== "" &&
        selectedCityAreaFilter?.label !== "General"
        ? `&city=${selectedCityAreaFilter?.value}`
        : "";

    const selectedState =
      selectedStateAreaFilter?.value !== "" &&
        selectedStateAreaFilter?.label !== "General"
        ? `&state=${selectedStateAreaFilter?.value}`
        : "";

    const selectedBusiness =
      selectedBusinessTypeFilter !== "" &&
        selectedBusinessTypeFilter !== "General"
        ? `&cid=${selectedBusinessTypeFilter}`
        : "";
    const response = await api.get(
      `/community-feeds?page=${pageFrom}&size=5${selectedState}${selectedCity}${selectedBusiness}&description=${searchTerm}`
    );

    const totalItems = response?.data?.response?.totalItems;
    // Calculate hasMore
    const currentLastItemIndex = pageFrom * 2;
    const hasMore = currentLastItemIndex < totalItems;

    setHasMore(hasMore);
    return response?.data?.response?.communityFeeds;
  };

  const loadMore = async (pageFrom) => {
    //console.logpage, pageFrom, "pageFrom");
    pageFrom = pageFrom != undefined ? pageFrom : page;
    setLoading(true);
    try {
      const newCommunities = await fetchData(pageFrom);
      if (pageFrom === 0) {
        setFetchCommunities([...newCommunities]);
      } else {
        setFetchCommunities([...fetchCommunities, ...newCommunities]);
      }
      setPage(pageFrom + 1);
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (inputRef.current === document.activeElement) {
      const fetchDataAsync = async () => {
        setLoading(true);
        try {
          setPage(0);
          const newCommunities = await fetchData(0);
          setFetchCommunities([...newCommunities]);
        } catch (error) {
          toast.error("Something went wrong");
        } finally {
          setLoading(false);
        }
      };
      setLoading(false);
      fetchDataAsync();
    }
  }, [searchTerm]);

  useEffect(() => {
    loadMore(page);
  }, []);

  useEffect(() => {
    if (
      (selectedStateAreaFilter !== "" ||
        selectedBusinessTypeFilter !== "" ||
        selectedCityAreaFilter !== "") &&
      page > 0
    ) {
      loadMore(0);
    }
  }, [
    selectedStateAreaFilter,
    selectedCityAreaFilter,
    selectedBusinessTypeFilter,
  ]);

  useEffect(() => {
    const fetchBusinessList = async () => {
      try {
        const res = await api.get("/business-type");
        if (res?.data?.status === 200) {
          setBusinessList([
            { id: "General", name: "General" },
            ...res?.data?.response,
          ]);
        }
      } catch (error) {
        toast.error("Error fetching business list");
      }
    };

    fetchBusinessList();
  }, []);

  const sortedArr = [
    ...businessList.filter((item) => item.name === "General"),
    ...businessList
      .filter((item) => item.name !== "General")
      .sort((a, b) => a.name.localeCompare(b.name)),
  ];

  const handleClearFilters = () => {
    // setSelectedAreaFilter({ label: "Area", value: "",type:"" });
    setSelectedStateAreaFilter({ label: "State", value: "", type: "" });
    setSelectedCityAreaFilter({ label: "City", value: "", type: "" });
    setSelectedBusinessTypeFilter("");
    setSearchTerm("");
    setPage(0);
    setFiltersCleared(true);
  };

  // const onChange = (e) => {
  //   // setSelectedAreaFilter(e);
  //   setSelectedCityAreaFilter(e);
  //   setSelectedStateAreaFilter(e);
  // };

  const handleStateChange = (selectedState) => {
    setSelectedStateAreaFilter(selectedState);
  };

  const handleCityChange = (selectedCity) => {
    setSelectedCityAreaFilter(selectedCity);
  };

  useEffect(() => {
    if (filtersCleared) {
      loadMore(0);
      setFiltersCleared(false);
    }
  }, [filtersCleared]);

  // const wrappedLoadOptions = useCallback((...args) => {
  //   return communityLoadOptions(...args);
  // }, []);
  const wrappedStateLoadOptions = useCallback((...args) => {
    return communityStateLoadOptions(...args);
  }, []);

  const wrappedCityLoadOptions = useCallback((...args) => {
    return communityCityLoadOptions(...args);
  }, []);

  const updateCommentCount = (id) => {
    const postIndex = fetchCommunities.findIndex(
      (post) => post.communityFeedId === id
    );
    if (postIndex === -1) return;

    const updatedPost = {
      ...fetchCommunities[postIndex],
      commentCount: fetchCommunities[postIndex].commentCount + 1,
    };
    const updatedPosts = [...fetchCommunities];
    updatedPosts[postIndex] = updatedPost;
    setFetchCommunities(updatedPosts);
  };

  //console.loghasMore, "hasMore", page, "Page ");

  return (
    <>
      <Navbar />
      <ToastContainer />
      <div className="container-fluid ">
        <div className="row">
          <div className="row mt-3">
            <div
              className="col-9  py-5 mt-4 custom-follow"
              style={{ backgroundColor: "#fff", height: "100vh" }}
            >
              <div className="d-flex custom-flex ">
                <h5 className=" mt-4 " style={{ marginRight: "1px" }}>
                  Community Board
                </h5>
                <div
                  className="form-group mr-1 position-relative ml-1 mr-1 mt-2"
                  style={{ width: "20%" }}
                >
                  <AsyncPaginate
                    formatOptionLabel={({ label, type }) => (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <strong>{label}</strong>
                        <small style={{ marginLeft: "auto" }}>{type}</small>
                      </div>
                    )}
                    styles={customStyles}
                    className={[className, " custom-placeholder"]}
                    debounceTimeout={300}
                    placeholder="State"
                    value={selectedStateAreaFilter}
                    loadOptions={wrappedStateLoadOptions}
                    onChange={handleStateChange}
                  />
                </div>

                <div
                  className="form-group mr-1 position-relative ml-1 mr-1 mt-2"
                  style={{ width: "20%" }}
                >
                  <AsyncPaginate
                    formatOptionLabel={({ label, type }) => (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <strong>{label}</strong>
                        {/* <small style={{ marginLeft: 'auto' }}>{type}</small> */}
                      </div>
                    )}
                    styles={customStyles}
                    className={[className, " custom-placeholder"]}
                    debounceTimeout={300}
                    placeholder="City"
                    value={selectedCityAreaFilter}
                    loadOptions={wrappedCityLoadOptions}
                    onChange={handleCityChange}
                  />
                </div>
                <div
                  className="form-group mr-3 position-relative ml-1 mr-1 px-1 mt-2"
                  style={{ width: "20%" }}
                >
                  <select
                    className="selectpicker mr-1 mt-2 ml-1 px-1 custumPadding"
                    id="dropdown2"
                    value={selectedBusinessTypeFilter}
                    onChange={handleBusinessTypeChange}
                  >
                    <option value="" disabled>
                      Business Type
                    </option>
                    {sortedArr?.map((item, index) => (
                      <option key={item?.id} value={item?.id}>
                        {item?.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group mr-1 position-relative ml-2 mr-1 mt-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <label htmlFor="flexSwitchCheckDefault">
                      <b
                        style={{
                          marginLeft: "5px",
                        }}
                      >
                        Show Media
                      </b>{" "}
                    </label>
                    <div
                      className="form-check form-switch "
                      style={{ marginLeft: 1 }}
                    >
                      <input
                        checked={showMedia}
                        className="form-check-input  "
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                        onChange={(e) => setShowMedia(e.target.checked)}
                        style={{
                          backgroundColor: "#f8d360",
                          borderColor: "#f8d360 ",
                        }}
                        color="#F5C000B2"
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="form-group mr-1 position-relative mt-3"
                  style={{ marginLeft: "1rem" }}
                >
                  <button
                    className="btn btn-outline-secondary btnClear"
                    onClick={handleClearFilters}
                    style={{ color: "#000" }}
                  >
                    Clear Filters
                  </button>
                </div>
              </div>
              {!loading && fetchCommunities?.length === 0 && <NoDataFound />}
              {loading && page === 0 ? (
                <CommunitySkeleton totalCount={2} loading={loading} />
              ) : (
                fetchCommunities?.length > 0 && (
                  <>
                    <CommunityList
                      loading={loading}
                      scrollableRef={scrollableRef}
                      hasMore={hasMore}
                      loadMore={loadMore}
                      page={page}
                      fetchCommunities={fetchCommunities}
                      showMedia={showMedia}
                      handleCloseLoginModal={handleCloseLoginModal}
                      handleShowLoginModal={handleShowLoginModal}
                      setShowLoginModal={setShowLoginModal}
                      showLoginModal={showLoginModal}
                      updateCommentCount={updateCommentCount}
                    />
                  </>
                )
              )}
            </div>

            <div
              className="col-3 d-flex flex-column py-5 mt-4 custom-padding"
              style={{ backgroundColor: "#fff", height: "100vh" }}
            >
              <div className="position-fixed mx-3">
                <div className="row mt-2 ">
                  <div className="col-sm-8 d-flex align-items-center ">
                    <div className="input-group w-100">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search a message"
                        value={searchTerm}
                        onChange={(e) => {
                          e.preventDefault();
                          setPage(0);
                          setSearchTerm(e.target.value);
                        }}
                        ref={inputRef}
                      />
                      <span className="input-group-text">
                        <i className="fa fa-search"></i>
                      </span>
                    </div>
                  </div>
                  <div className="col-sm-4 d-flex align-items-center justify-content-end">
                    <button
                      type="button"
                      className="border-0"
                      onClick={handleShow}
                      style={{
                        backgroundColor: "#F5C000",
                        borderRadius: "5px",
                        padding: "5px 10px",
                      }}
                    >
                      <span style={{ fontSize: "1em", textAlign: "center" }}>
                        Ask Question
                      </span>
                    </button>
                  </div>
                </div>
              </div>

              <CommunityRightSection />
            </div>
          </div>
        </div>
      </div>
      <CommunityModal
        loadMore={loadMore}
        handleClose={handleClose}
        show={show}
        businessList={businessList}
        setPage={setPage}
        form={form}
        setForm={setForm}
        setIsNewCommunity={setIsNewCommunity}
        setEdit={false}
        media={feedMedia}
      />

      <LoginModal show={showLoginModal} handleClose={handleCloseLoginModal} />
    </>
  );
};

export default CommunityBoard;
